export const DistributorCensoredColumns = [
  'nfPrice',
  'markup',
  'institutionValue',
  'opportunityValue'
];
